// 저장 안내 한 줄(대화 저장 · 녹화 저장) — 성공은 초록, 실패는 붉게. 앱이면 [폴더 열기]로 저장한 파일을 보여 준다.
//
// 🔴 성공을 **말없이 넘기지 않는다**(2026-09-24 Mac 실기 — 파일은 생겼는데 사람은 "반응 없음" 으로 봤다).
// 누르면 닫힌다. [폴더 열기]는 닫지 않고 연다(열고 나서도 경로를 다시 볼 수 있게).

import { IS_SHELL } from '../shell';
import type { SaveNotice } from '../download';
import { revealSavedFile } from '../download';

export function SaveNoticeBar({
  notice,
  onClose,
  className,
}: {
  notice: SaveNotice;
  onClose: () => void;
  /** 자리 잡기용 클래스(채팅 패널 안 · 무대 아래 가운데 등). */
  className: string;
}) {
  return (
    <div
      className={`${className} ${notice.kind}`}
      role="status"
      onClick={onClose}
      title="눌러서 닫기"
    >
      <span className="save-notice-text">{notice.text}</span>
      {IS_SHELL && notice.path && (
        <button
          className="ghost"
          onClick={(e) => {
            e.stopPropagation(); // 안내를 닫지 않는다
            // 실패해도 경로는 이미 안내에 있다 — 사람이 직접 찾아갈 수 있다.
            void revealSavedFile(notice.path ?? '').catch(() => undefined);
          }}
        >
          📂 폴더 열기
        </button>
      )}
    </div>
  );
}
